import {Component, Input, Output, EventEmitter, OnInit, OnChanges} from '@angular/core';
import {Location} from '@angular/common';
import {FormControl} from '@angular/forms';
import {FooterComponent} from '../footer/footer.component';
import {ConfService} from '../conf.service';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {Router} from '@angular/router';


@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit, OnChanges {

    @Input() isServerStatusPanelOpened = false;
    @Output() isHelpButtonClicked: EventEmitter<any> = new EventEmitter<any>();
    @Output() marginRemove: EventEmitter<any> = new EventEmitter<any>();
    mode = new FormControl('over');
    // @Input() documentationData = <any> {};
    // isExpand: boolean = false;
    // expandedTab = '';
    @Input() docType: any;
    helpType = '';
    height = 200;
    width = 340;
    startSeconds = 0;
    endSeconds = 0;
    suggestedQuality = 'highres';
    videos = [
        {
            'contentType': 'video',
            'details': {
                'videoId': 'cjQnS3dAiEs',
                'title': 'Introduction to apiplatform.io'
            },
            'source': 'youtube',
            'id': 1
        },
        {
            'contentType': 'video',
            'details': {
                'videoId': 'Q-YIVseTkEM',
                'title': 'Set up environment'
            },
            'source': 'youtube',
            'id': 2
        },
        {
            'contentType': 'video',
            'details': {
                'videoId': 'DplIIbrr29c',
                'title': 'Partner sign up'
            },
            'source': 'youtube',
            'id': 3
        },
        {
            'contentType': 'video',
            'details': {
                'videoId': 'nlnCtyvJUHI',
                'title': 'An introduction to navigate within apiplatform.io'
            },
            'source': 'youtube',
            'id': 4
        },
        {
            'contentType': 'video',
            'details': {
                'videoId': 'dAyZQM4W2eQ',
                'title': 'Create a Data Access API'
            },
            'source': 'youtube',
            'id': 5
        },
        {
            'contentType': 'video',
            'details': {
                'videoId': 'qs-uX40ATFY',
                'title': 'Manage Data Access API'
            },
            'source': 'youtube',
            'id': 6
        },
        {
            'contentType': 'video',
            'details': {
                'videoId': '0fWf6zONOb4',
                'title': 'Data Access API in Mongo DB with Reference Key'
            },
            'source': 'youtube',
            'id': 7
        },
        {
            'contentType': 'video',
            'details': {
                'videoId': 'dZaVSHSd2f8',
                'title': 'Create Data Access API using Foreign Key'
            },
            'source': 'youtube',
            'id': 8
        },
        {
            'contentType': 'video',
            'details': {
                'videoId': 'YY4PzvHOOuE',
                'title': 'Explore Business Logic Builder'
            },
            'source': 'youtube',
            'id': 9
        },
        {
            'contentType': 'video',
            'details': {
                'videoId': 'd_9I8GYpybA',
                'title': 'Data Access API in Business Logic API'
            },
            'source': 'youtube',
            'id': 10
        },
        {
            'contentType': 'video',
            'details': {
                'videoId': 'DlyoS-C7m04',
                'title': 'Build your SQL Query'
            },
            'source': 'youtube',
            'id': 11
        },
        {
            'contentType': 'video',
            'details': {
                'videoId': 'JG8-05s7TLQ',
                'title': 'Create Data Access API with Mongo DB'
            },
            'source': 'youtube',
            'id': 12
        }
    ];
    data = {
        'title': 'untitled',
        'videoId': '',
        'note': '',
        'content': [
            {
                'main': '',
                'header': [
                    {
                        'name': '',
                        'items': [
                            {
                                'text': '',
                                'sublist': []
                            }
                        ]
                    }
                ],
            }
        ]
    };
    docData: any;

    constructor(public footer: FooterComponent, private location: Location, private confPost: ConfService) {
    }

    ngOnInit() {
        this.initializeData();
        window.addEventListener('resize', this.docResize);
    }

    initializeData() {
        if (this.footer.docData) {
            this.docData = this.footer.docData;
            this.getData();
        } else {
            this.confPost.getData('services', 'services', 'v1', 'referenceDocs', null).subscribe(res => {
                this.docData = res;
                this.footer.docData = this.docData;
                this.getData();
            });
        }
    }

    getData() {
        if (this.docData) {
            let flag = false;
            for (const item of this.docData) {
                if (this.docType === 'dataaccessapi' && item.title === 'Data as a Service') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'dataaccessapi-advanced' && item.title === 'Data as a Service (Advanced)') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'businesslogic' && item.title === 'Application Logic') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'querybuilder' && item.title === 'SQL as a Service') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'plsql' && item.title === 'PLSQL as a Service') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'workflow' && item.title === 'Workflows') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'unified-query-builder' && item.title === 'API Joins') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'application' && item.title === 'Design2API') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'postman-collections' && item.title === 'Postman Collection') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'api-register' && item.title === 'API Register') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'coboltoapi' && item.title === 'COBOL2API') {
                    this.data = item;
                    flag = true;
                    break;
                } else if ((this.docType === 'databases' || this.docType === 'datacatalog') && item.title === 'Data2API') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'apitoapi' && item.title === 'Another Data API') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'jsontoapi' && item.title === 'JSON Schema') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'providers' && item.title === 'API Providers') {
                    this.data = item;
                    flag = true;
                    break;
                } else if ((this.docType === 'emailtemplatebuilder' || this.docType === 'email-templates') && item.title === 'Email Template Builder') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'apiql' && item.title === 'APIQL Engine') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'dataql' && item.title === 'DATAQL Engine') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'collection' && item.title === 'API Collection') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'devex' && item.title === 'API Tester') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'scheduler' && item.title === 'Scheduler') {
                    this.data = item;
                    flag = true;
                    break;
                } else if ((this.docType === 'test-results' || this.docType === 'testsuite') && item.title === 'Test Suite as a Service') {
                    this.data = item;
                    flag = true;
                    break;
                } else if (this.docType === 'filestorage' && item.title === 'File Manager') {
                    this.data = item;
                    flag = true;
                    break;
                } else {
                    this.data = {
                        'title': 'apiplatform.io',
                        'videoId': 'dAyZQM4W2eQ',
                        'note': 'apiplatform.io is a cloud-agnostic no-code platform which helps you to model, generate, launch, track and manage APIs with a few clicks and configurations. Our platform is the industry’s first end-to-end API engineering and management platform to deliver a bunch of applications and services.',
                        'content': [
                            {
                                'main': 'Create a Data Access Service',
                                'header': [
                                    {
                                        'name': 'On the left panel, click on the "+" icon and select Data Access API',
                                        'items': []
                                    },
                                    {
                                        'name': 'After clicking on Data Access API, enter the below details. ',
                                        'items': []
                                    },
                                    {
                                        'name': 'Enter API Name *',
                                        'items': [
                                            {
                                                'text': 'Give a name for the API you wanted to create. In order to provide consistent developer experience across many APIs and over a long period of time, all names used by an API should be :',
                                                'sublist': [
                                                    'Simple',
                                                    'Intuitive',
                                                    'Consistent'
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'Version *',
                                        'items': [
                                            {
                                                'text': 'The version of an API always allow you to alter behaviour between different APIs with same name.',
                                                'sublist': []
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'Database *',
                                        'items': [
                                            {
                                                'text': 'Select the Database type.',
                                                'sublist': ['mongodb-us-east1 is the default database provided', 'You can also select the desired database which is already configured']
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'Table Name *',
                                        'items': [
                                            {
                                                'text': 'Enter the Table Name. Table Name is the name of the database object in which you would like to store the data for the API being created.',
                                                'sublist': []
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'API Gateway *',
                                        'items': [
                                            {
                                                'text': 'Select the API Gateway.',
                                                'sublist': ['apiplatform.io is the default API Gateway provided', 'You can also select the desired API Gateway which is already configured']
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'Category Type',
                                        'items': [
                                            {
                                                'text': 'Enter the Category Type. Category is the logical group of APIs to better organize the display of APIs in dashboard. Though it is optional, it is recommended to enter a meaningful category of the API for improved searchability.',
                                                'sublist': []
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'API Display Name',
                                        'items': [
                                            {
                                                'text': 'Enter the API Display Name. It is the name through which the API is displayed in console.',
                                                'sublist': []
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'API Description',
                                        'items': [
                                            {
                                                'text': ' Enter the API Description. Provide a short description to your API. It is optional.',
                                                'sublist': []
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'Method Type *',
                                        'items': [
                                            {
                                                'text': 'Select the API Method Type from the dropdown.',
                                                'sublist': []
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'Publish API',
                                        'items': [
                                            {
                                                'text': 'Select Publish API checkbox if you want to publish the API for consumption. After selecting the option to publish select the scope of access for the API whether it is Public or Private.',
                                                'sublist': []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                'main': 'Schema Definition for Data Access Service',
                                'header': [
                                    {
                                        'name': 'Attribute Name *',
                                        'items': [
                                            {
                                                'text': 'Enter the Name of the Attribute in the name field. It is recommended to use a non-space non-special character in the name of an attribute.',
                                                'sublist': []
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'Data Type *',
                                        'items': [
                                            {
                                                'text': 'Select the desired Data Type from the dropdown. The Data Type depends on the Database selected.',
                                                'sublist': []
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'Size',
                                        'items': [
                                            {
                                                'text': 'Enter the length of the attribute value in the Size column. It is used for SQL databases.',
                                                'sublist': []
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'precision',
                                        'items': [
                                            {
                                                'text': 'Enter the precision of the attribute value in the Attribute column. Precision ranges between 0 and 1. It is used for SQL databases.',
                                                'sublist': []
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'Key',
                                        'items': [
                                            {
                                                'text': 'Select the Key type of the attribute entered as None, Primary or Unique.It is used for SQL databases.',
                                                'sublist': []
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'Required',
                                        'items': [
                                            {
                                                'text': 'Check the Required Box if the attribute is required. If it is selected, the attribute becomes NOT NULL or NON EMPTY field.',
                                                'sublist': []
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'Auto-Increment',
                                        'items': [
                                            {
                                                'text': 'Auto-increment field can be selected for Primary keys.',
                                                'sublist': []
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'Default Value',
                                        'items': [
                                            {
                                                'text': 'Enter the default value for the attribute in the Default Value column. When a value is not set for an attribute, default value is fed.',
                                                'sublist': []
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'Add or Delete Attribute',
                                        'items': [
                                            {
                                                'text': 'Add or Delete an attribute by clicking ‘+\' or \'-\' buttons respectively',
                                                'sublist': []
                                            }
                                        ]
                                    },
                                    {
                                        'name': 'Describe',
                                        'items': [
                                            {
                                                'text': 'Click on Describe button to describe more about the attribute in the pop-up appeared,Select the Data Storage, API Access and Display policy from the dropdowns.',
                                                'sublist': []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                'main': 'Deploy Data Access Service',
                                'header': [
                                    {
                                        'name': 'Finally, click on Deploy to create your API, the schema for the Data Access Service will be retrieved from the response of the given input API.',
                                        'items': []
                                    },
                                    {
                                        'name': 'Once the Data Access Service is deployed, the API endpoints for the selected API methods will be displayed.',
                                        'items': []
                                    }
                                ]
                            },
                        ]
                    };

                }
            }
            if (flag === false) {
                this.data = {
                    'title': 'apiplatform.io',
                    'videoId': 'dAyZQM4W2eQ',
                    'note': 'apiplatform.io is a cloud-agnostic no-code platform which helps you to model, generate, launch, track and manage APIs with a few clicks and configurations. Our platform is the industry’s first end-to-end API engineering and management platform to deliver a bunch of applications and services.',
                    'content': [
                        {
                            'main': 'Create a Data Access Service',
                            'header': [
                                {
                                    'name': 'On the left panel, click on the "+" icon and select Data Access API',
                                    'items': []
                                },
                                {
                                    'name': 'After clicking on Data Access API, enter the below details. ',
                                    'items': []
                                },
                                {
                                    'name': 'Enter API Name *',
                                    'items': [
                                        {
                                            'text': 'Give a name for the API you wanted to create. In order to provide consistent developer experience across many APIs and over a long period of time, all names used by an API should be :',
                                            'sublist': [
                                                'Simple',
                                                'Intuitive',
                                                'Consistent'
                                            ]
                                        }
                                    ]
                                },
                                {
                                    'name': 'Version *',
                                    'items': [
                                        {
                                            'text': 'The version of an API always allow you to alter behaviour between different APIs with same name.',
                                            'sublist': []
                                        }
                                    ]
                                },
                                {
                                    'name': 'Database *',
                                    'items': [
                                        {
                                            'text': 'Select the Database type.',
                                            'sublist': ['mongodb-us-east1 is the default database provided', 'You can also select the desired database which is already configured']
                                        }
                                    ]
                                },
                                {
                                    'name': 'Table Name *',
                                    'items': [
                                        {
                                            'text': 'Enter the Table Name. Table Name is the name of the database object in which you would like to store the data for the API being created.',
                                            'sublist': []
                                        }
                                    ]
                                },
                                {
                                    'name': 'API Gateway *',
                                    'items': [
                                        {
                                            'text': 'Select the API Gateway.',
                                            'sublist': ['apiplatform.io is the default API Gateway provided', 'You can also select the desired API Gateway which is already configured']
                                        }
                                    ]
                                },
                                {
                                    'name': 'Category Type',
                                    'items': [
                                        {
                                            'text': 'Enter the Category Type. Category is the logical group of APIs to better organize the display of APIs in dashboard. Though it is optional, it is recommended to enter a meaningful category of the API for improved searchability.',
                                            'sublist': []
                                        }
                                    ]
                                },
                                {
                                    'name': 'API Display Name',
                                    'items': [
                                        {
                                            'text': 'Enter the API Display Name. It is the name through which the API is displayed in console.',
                                            'sublist': []
                                        }
                                    ]
                                },
                                {
                                    'name': 'API Description',
                                    'items': [
                                        {
                                            'text': ' Enter the API Description. Provide a short description to your API. It is optional.',
                                            'sublist': []
                                        }
                                    ]
                                },
                                {
                                    'name': 'Method Type *',
                                    'items': [
                                        {
                                            'text': 'Select the API Method Type from the dropdown.',
                                            'sublist': []
                                        }
                                    ]
                                },
                                {
                                    'name': 'Publish API',
                                    'items': [
                                        {
                                            'text': 'Select Publish API checkbox if you want to publish the API for consumption. After selecting the option to publish select the scope of access for the API whether it is Public or Private.',
                                            'sublist': []
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            'main': 'Schema Definition for Data Access Service',
                            'header': [
                                {
                                    'name': 'Attribute Name *',
                                    'items': [
                                        {
                                            'text': 'Enter the Name of the Attribute in the name field. It is recommended to use a non-space non-special character in the name of an attribute.',
                                            'sublist': []
                                        }
                                    ]
                                },
                                {
                                    'name': 'Data Type *',
                                    'items': [
                                        {
                                            'text': 'Select the desired Data Type from the dropdown. The Data Type depends on the Database selected.',
                                            'sublist': []
                                        }
                                    ]
                                },
                                {
                                    'name': 'Size',
                                    'items': [
                                        {
                                            'text': 'Enter the length of the attribute value in the Size column. It is used for SQL databases.',
                                            'sublist': []
                                        }
                                    ]
                                },
                                {
                                    'name': 'precision',
                                    'items': [
                                        {
                                            'text': 'Enter the precision of the attribute value in the Attribute column. Precision ranges between 0 and 1. It is used for SQL databases.',
                                            'sublist': []
                                        }
                                    ]
                                },
                                {
                                    'name': 'Key',
                                    'items': [
                                        {
                                            'text': 'Select the Key type of the attribute entered as None, Primary or Unique.It is used for SQL databases.',
                                            'sublist': []
                                        }
                                    ]
                                },
                                {
                                    'name': 'Required',
                                    'items': [
                                        {
                                            'text': 'Check the Required Box if the attribute is required. If it is selected, the attribute becomes NOT NULL or NON EMPTY field.',
                                            'sublist': []
                                        }
                                    ]
                                },
                                {
                                    'name': 'Auto-Increment',
                                    'items': [
                                        {
                                            'text': 'Auto-increment field can be selected for Primary keys.',
                                            'sublist': []
                                        }
                                    ]
                                },
                                {
                                    'name': 'Default Value',
                                    'items': [
                                        {
                                            'text': 'Enter the default value for the attribute in the Default Value column. When a value is not set for an attribute, default value is fed.',
                                            'sublist': []
                                        }
                                    ]
                                },
                                {
                                    'name': 'Add or Delete Attribute',
                                    'items': [
                                        {
                                            'text': 'Add or Delete an attribute by clicking ‘+\' or \'-\' buttons respectively',
                                            'sublist': []
                                        }
                                    ]
                                },
                                {
                                    'name': 'Describe',
                                    'items': [
                                        {
                                            'text': 'Click on Describe button to describe more about the attribute in the pop-up appeared,Select the Data Storage, API Access and Display policy from the dropdowns.',
                                            'sublist': []
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            'main': 'Deploy Data Access Service',
                            'header': [
                                {
                                    'name': 'Finally, click on Deploy to create your API, the schema for the Data Access Service will be retrieved from the response of the given input API.',
                                    'items': []
                                },
                                {
                                    'name': 'Once the Data Access Service is deployed, the API endpoints for the selected API methods will be displayed.',
                                    'items': []
                                }
                            ]
                        },
                    ]
                };
            }
        }

    }

    docResize() {
        const ribbonHeight = document.getElementById('header-ribbon').offsetHeight;
        const footerHeight = document.getElementById('page-footer').offsetHeight;
        document.getElementById('draggable-doc').style.top = String(ribbonHeight) + 'px';
        document.getElementById('draggable-doc').style.bottom = String(footerHeight) + 'px';
    }
    toggleSideNav(sidePanel) {
        this.helpType = sidePanel;
        this.openNav();
        this.docResize();
        // this.isServerStatusPanelOpened = !this.isServerStatusPanelOpened;
        // this.isServerStatusPanelStateChanged.emit();
    }

    closeSideNav() {
        this.isServerStatusPanelOpened = false;
    }

    ngOnChanges() {
        // this.getData();
    }

    openNav() {
        this.isHelpButtonClicked.emit();
        document.getElementById('draggable-doc').style.width = '400px';
        // document.getElementById('draggable-doc').style.height = '40vh';
        document.getElementById('draggable-doc').style.display = 'block';
    }

    closeNav() {
        this.marginRemove.emit();
        document.getElementById('draggable-doc').style.width = '0';
        // document.getElementById('draggable-doc').style.height = '0';
        document.getElementById('draggable-doc').style.display = 'none';
    }
}
